<template>
  <div class="orderDt">
    <van-nav-bar :title="title" 
      left-arrow
      @click-left="onClickLeft"
      class="topBar"
    />
    <div style="height:45px"></div>
    
    <!-- 生产检验 -->
    <van-tabs v-model="activeName" class="bqs" @change="ckActve">
      <van-tab title="未读消息" name="未读消息"></van-tab>
      <van-tab title="所有消息" name="所有消息"></van-tab>
      <!-- <van-tab title="我发送的消息" name="我发送的消息"></van-tab> -->
    </van-tabs>
    <div class="van-cell setBox noLine gdItem" v-for="(item,index) in yhList" :key="index" @click="goXf(item)">
      <div class="flex1 setBox noLine">
        <div class="flex1">
          <b>
            消息内容：{{item.title}}<br/> 时间：{{item.sj}}
          </b>
        </div>
       <div class="flex1">
         <div class="noread" v-if="avtive=='未读消息'">
           未读
         </div>
         <div style="margin-top:5px">
           {{item.tbtime}}
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _URL from "../../lib/url";
  import { Toast, Dialog, RadioGroup, Radio, PullRefresh } from "vant";
  import { getAction, postAction } from "@/api/manage";
  export default {
    name: "index",
    data: function () {
      return {
          activeName: '已提交待下发',
          title: this.$route.query.title,
          yhList:[],
          avtive:'未读消息'
      };
    },
    mounted: function () {
      let that = this;
      //获取消息列表
      that.getList(_URL.jsXxlist)
      let active =  localStorage.getItem('active')
      if(!active){
        active = 0
      }
      that.activeName = active;
    },
    methods: {
      goXf(item){
        let that = this;
        if(that.avtive=="未读消息"){
            let obj = {
              isread:1,
              id:item.id
            };
            Toast.loading({
              message: "跳转中...",
              forbidClick: true,
              duration: 0,
            });
            postAction(_URL.xxReadSave, obj).then((res) => {
              console.log(JSON.stringify(res));
              Toast.clear();
              //that.goans(item);
              that.getList(_URL.jsXxlist)
            });
        }else{
          //that.goans(item);
        }
          
      },
      goans(item){
        let that = this;
           switch(item.type) {
            case 'yhzg':  //整改
                that.go('yhzg','add','巡检整改')
                break;
            case 'yhxf':  //下发
                that.go('yhxf','add','巡检列表')
                break;
            case 'yhsq':  //延期审批
                that.go('yqsp','add','延期审批')
                break;
            case 'yhsb':  //巡检上报
                that.go('things','add','巡检上报')
                break;
            case 'yhys':  //巡检验收
                that.go('zgys','add','整改验收')
                break;
            default:
        }
      },
      go(url,type,title){
        this.$router.push({
          path:url,
          query:{
            type:type,
            title:title
          }
        });
      },
      getList(url){
          let that = this;
          let user =  JSON.parse(localStorage.getItem('user'))
          let obj = {
            flag:'gwyhsb',
            fzrids:user.id,
            isread:-1,
            pageNum:1,
            pageSize:100
          };
          Toast.loading({
            message: "数据加载中...",
            forbidClick: true,
            duration: 0,
          });
          getAction(url, obj).then((res) => {
            //console.log(JSON.stringify(res));
            Toast.clear();
            that.yhList = res.data.rows;
          });
      },
      getListAll(url){
          let that = this;
          let user =  JSON.parse(localStorage.getItem('user'))
          let obj = {
            flag:'gwyhsb',
            fzrids:user.id,
            pageNum:1,
            pageSize:10000
          };
          Toast.loading({
            message: "数据加载中...",
            forbidClick: true,
            duration: 0,
          });
          getAction(url, obj).then((res) => {
            console.log(JSON.stringify(res));
            Toast.clear();
            that.yhList = res.data.rows;
          });
      },
      ckActve(avtive){
        let that = this
        that.avtive = avtive
        if(avtive=="未读消息"){
          that.getList(_URL.jsXxlist)
        }
        if(avtive=="所有消息"){
          that.getListAll(_URL.jsXxlistAll)
        }
      },
      onClickLeft: function() {
        this.$router.go(-1);
      },
    },
  };
</script>
<style lang="less">
  .orderDt{
    .noread{
      color: red;
      border:solid 1px red;
      width:40px;
      text-align: center;
      border-radius: 5px;
      float: left;
      margin-right: 10px;
      height: 22px;
      line-height: 20px;
      margin-top: 6px;
    }
    .rightBtn{
        font-size:20px;
        position: relative;
        float: right;
        top:2px;
        margin-left:10px
    }
    .cptit{
        font-size:17px;
    }
    .progressd{
        width:90%;
        margin-left:5%;
    }
    .progs{
        position: relative;
        top:11px
    }
    .van-tabs__line{
      background-color: #1773f8;
    }
  }
</style>
  
  